export default __webpack_public_path__ + "static/media/cabina-sonido.3793d144.jpeg";